import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const logoutAll = createAsyncThunk('master-user/logout-all', async (_, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/master-user/logout-all`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json().catch(() => ({}));
    // 401 means the session is already gone server-side, which is what logout wants.
    if (!response.ok && response.status !== 401) return rejectWithValue(result);
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  response: [],
  error: null,
};

const LogoutAll = createSlice({
  name: 'LogoutAll',
  initialState,
  reducers: {},
  extraReducers: {
    [logoutAll.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [logoutAll.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [logoutAll.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export default LogoutAll; 